import { createContext } from 'react';

import { RequestAccessFormState } from './types';

/* istanbul ignore next -- @preserve */
const defaultState: RequestAccessFormState = {
    step: 0,
    selectedAccounts: [],
    selectedLocations: [],
    directoryUserAccountId: undefined,
    directoryUserAccountSecret: '',
    userEmail: '',
    setStep: () => {},
    setSelectedAccounts: () => {},
    setSelectedLocations: () => {},
    setDirectoryUserAccountId: () => {},
    setDirectoryUserAccountSecret: () => {},
    setUserEmail: () => {},
};

const RequestAccessFormContext = createContext<RequestAccessFormState>(defaultState);

export { RequestAccessFormContext, defaultState };
